import type { IInputIntModelValueType, IInputIntPropsWithoutModelValue } from '@/components';
import { reactive, type Ref } from 'vue';
import { DropdownItemBase } from './DropdownItemBase';

type IDropdownItemIntInput = {
    [K in keyof IInputIntPropsWithoutModelValue]: undefined extends IInputIntPropsWithoutModelValue[K]
        ? IInputIntPropsWithoutModelValue[K] | Ref<Exclude<IInputIntPropsWithoutModelValue[K], undefined>> | undefined
        : IInputIntPropsWithoutModelValue[K] | Ref<IInputIntPropsWithoutModelValue[K]>;
};

export class DropdownItemIntInput extends DropdownItemBase {
    modelValue: Ref<IInputIntModelValueType>;

    props: IInputIntPropsWithoutModelValue;

    get uniqueLoopKey() {
        return `${this.props.id}-${this.props.label}-${this.props.placeholder}-${this.props.icon}`;
    }

    private abuseBlocker: boolean = false;

    private constructor(modelValue: Ref<number>, props: IDropdownItemIntInput, hideDropDownItem?: Ref<boolean>) {
        super();
        this.modelValue = modelValue;
        this.hideDropDownItem = hideDropDownItem;

        this.props = reactive(props);
    }

    public static create(
        options: { modelValue: Ref<number> } & IDropdownItemIntInput & Pick<DropdownItemBase, 'hideDropDownItem'>,
    ): DropdownItemIntInput {
        const { modelValue, hideDropDownItem, ...props } = options;
        return new DropdownItemIntInput(modelValue, props, hideDropDownItem);
    }
}
